/*
 * サブシステム名：マスタ管理
 * 機能名：ジャンルマスタ一覧
 */

import DdDataTable from '@/components/DdDataTable'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTextBox from '@/components/DdTextBox'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
// import header from '@/ddv2.library/header'

export default {
  name: 'MstJenreList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      jenreNm: ''
    },
    isShowAllTemplate: false,
    modeKengen: 0,
    page: 1,
    editorOption: {
      theme: 'bubble',
      placeholder: '',
      modules: {
        toolbar: []
      }
    }
  }),
  components: {
    DdDataTable,
    DdDefaultButton,
    DdFooterButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  computed: {
    filteredRows () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      }).filter((elem) => {
        if ((!self.isShowAllTemplate && (elem.tekiyoStartYmdDisp > target || elem.tekiyoEndYmdDisp < target))) return false
        return true
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun', 'msthinmei'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('mstTgChecksheet.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: 'ジャンルコード', value: 'jenreCd' },
              { text: 'ジャンル名', value: 'jenreNm' },
              { text: 'メール用特記事項', value: 'mailSupplementText' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hinmeiCd: '',
              sagyoKbnCd: '',
              checksheetFileNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('mstTgChecksheet.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('mstTgChecksheet.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('mstTgChecksheet.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('mstTgChecksheet.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('mstTgChecksheet.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/MstTgJenre/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              hinmeiCd: '',
              sagyoKbn: '',
              checksheetFileNm: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []

            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/mstTgChecksheet/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
